import { type AppCustomClaims } from "./normalizeCustomClaims";

interface LoggedUserIdentity {
  customClaims: AppCustomClaims | null;
  id: string;
}

export const getTeamOwnerId = ({ customClaims, id }: LoggedUserIdentity): string => customClaims?.trainerId ?? id;
